export default {
  NO_ROLES: 90000
}


// WEBPACK FOOTER //
// ./src/scripts/error.js